import { defineStore } from "pinia";
import { useUserStore} from "~/stores/user";

export const useLocalStorageStore = defineStore('localStorage', () => {
    const config = useRuntimeConfig();
    const userStore = useUserStore();

    const getDomAirports = () => {
        try {
            const data = localStorage.getItem('domesticAirports');
            if(data){
                const airports = JSON.parse(data);
                return airports;
            }
        } catch (error) {
            return error
        }
    }


    const getInternationalAirport = () => {
        try {
            const data = localStorage.getItem('internationalAirports');
            if(data){
                const airports = JSON.parse(data);
                return airports;
            }
        } catch (error) {
            return error
        }
    }


    const getStations = () => {
        try {
            const data = localStorage.getItem('stations');
            if(data){
                const stations = JSON.parse(data);
                return stations;
            }
        } catch (error) {
            return error
        }
    }


    const getHarbours = () => {
        try {
            const data = localStorage.getItem('harbours');
            if(data){
                const harbours = JSON.parse(data);
                return harbours;
            }
        } catch (error) {
            return error
        }
    }

    const getPassengers = () => {
        try {
            const data = localStorage.getItem('passengers');
            if(data){
                const passengers = JSON.parse(data);
                return passengers;
            }
        } catch (error) {
            return error
        }
    }

    const getFCMToken = () => {
        try {
            const data = localStorage.getItem('fcmToken');
            if(data){
                const fcmToken = data;
                return fcmToken;
            }
        } catch (error) {
            return error
        }
    }


    const getAirlinesCode = () =>{
        try{
            const data = localStorage.getItem('airlinesCode');
            if(data){
                const airlinesCode = JSON.parse(data);
                return airlinesCode;
            }
        }catch(error){
            return error;
        }
    }

    const getAddres = () => {
        try {
            const data = localStorage.getItem('addreses');
            if(data){
                const addres = JSON.parse(data);
                return addres;
            }
        } catch (error) {
            return error
        }
    }

    return { getDomAirports,getInternationalAirport,getStations,getHarbours,getPassengers,getAirlinesCode,getAddres,getFCMToken }
});